<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <!-- <el-input
          v-model="form['Name:like']"
          placeholder="产品名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp; -->
        <select2
          v-model="form.SoftwareID"
          url="software"
          labelName="Name"
          placeholder="请选择产品"
          no-data-text="无产品"
        ></select2>&nbsp;
        <el-select v-model="form.CheckStatus" clearable placeholder="请选择审核状态">
          <el-option
            v-for="item in check"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      />
      <el-table-column prop="Software.Name" label="产品名称" />
      <el-table-column prop="Version" label="审核版本" />
      <el-table-column prop="CheckStatus" label="审核状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.CheckStatus === 1" type="info">未审核</el-tag>
          <el-tag v-if="scope.row.CheckStatus === 2" type="success">审核通过</el-tag>
          <el-tag v-if="scope.row.CheckStatus === 3" type="warning">审核未通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CreatedAt" label="上传日期">
        <template slot-scope="scope">
          <div v-if="scope.row.CreatedAt">
            {{scope.row.CreatedAt.substring(0,10)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Provider" label="上传者" />
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="success"
            @click.stop="changeCheck(scope.row,2)"
            title="通过"
            :disabled="scope.row.CheckStatus===2 || scope.row.CheckStatus===3"
          >
            <i class="fas fa-check-circle"></i>
          </el-button>
          <el-button
            type="warning"
            @click.stop="changeCheck(scope.row,3)"
            title="不通过"
            :disabled="scope.row.CheckStatus===2 || scope.row.CheckStatus===3"
          >
            <i class="fas fa-times-circle"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      check: [
        {
          value: 1,
          label: '未审核',
        },
        {
          value: 2,
          label: '已审核',
        },
      ],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        // 'Name:like': '',
        SoftwareID: '',
        CheckStatus: '',
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      updateVisible: false,
    };
  },
  mounted() { },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('software/version', {
        params: {
          where: this.form,
          with: ['Software'],
          ...this.pager,
        },
      }).then((response) => {
        this.itemList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        Name: '',
        Type: '',
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除此软件吗？', '提示').then(
        () => this.$axios.delete(`software/${row.ID}`)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除分组');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    onUpdatePack(row) {
      this.item = row;
      this.updateVisible = true;
    },
    changeCheck(row, status) {
      this.$confirm('确定审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.put(`checksoftwareversion/${row.ID}`, { CheckStatus: status }).then(() => {
          if (status === 2) {
            this.$message({
              type: 'success',
              message: '审核通过!',
            });
          }
          if (status === 3) {
            this.$message({
              type: 'warning',
              message: '审核不通过!',
            });
          }
          this.getItemList();
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
      }).catch(() => {
        this.$message({
          type: 'warning',
          message: '已取消',
        });
      });
    },
  },
};
</script>
